import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceHero from '../components/ServiceHero';
import ServiceFeatures from '../components/ServiceFeatures';
import ServiceDetails from '../components/ServiceDetails';
import ServiceCTA from '../components/ServiceCTA';
import { useTranslation } from 'react-i18next';

export default function ITServicesPage() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-server-line', title: t('servicePages.it.features.f1.title'), desc: t('servicePages.it.features.f1.desc') },
    { icon: 'ri-database-2-line', title: t('servicePages.it.features.f2.title'), desc: t('servicePages.it.features.f2.desc') },
    { icon: 'ri-cloud-line', title: t('servicePages.it.features.f3.title'), desc: t('servicePages.it.features.f3.desc') },
    { icon: 'ri-shield-check-line', title: t('servicePages.it.features.f4.title'), desc: t('servicePages.it.features.f4.desc') },
    { icon: 'ri-settings-3-line', title: t('servicePages.it.features.f5.title'), desc: t('servicePages.it.features.f5.desc') },
    { icon: 'ri-customer-service-2-line', title: t('servicePages.it.features.f6.title'), desc: t('servicePages.it.features.f6.desc') },
  ];

  const details = [
    {
      label: t('servicePages.it.details.d1.label'),
      title: t('servicePages.it.details.d1.title'),
      body: t('servicePages.it.details.d1.body'),
      image: 'https://public.readdy.ai/ai/img_res/51b7650620574dd1c1e95f2cc47c0b2b.jpg',
      reverse: false,
    },
    {
      label: t('servicePages.it.details.d2.label'),
      title: t('servicePages.it.details.d2.title'),
      body: t('servicePages.it.details.d2.body'),
      image: 'https://readdy.ai/api/search-image?query=data%20center%20server%20room%20with%20glowing%20blue%20LED%20lights%2C%20rows%20of%20servers%2C%20dark%20background%20with%20cyan%20neon%20reflections%2C%20futuristic%20infrastructure%2C%20abstract%20network%20cables%20and%20hardware%2C%20professional%20hosting%20environment%2C%20no%20people%2C%20cinematic%20lighting&width=800&height=500&seq=it-detail-02&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0f1419]">
      <Header />
      <main>
        <ServiceHero
          icon="ri-code-s-slash-line"
          label={t('servicePages.it.label')}
          title={t('servicePages.it.title')}
          subtitle={t('servicePages.it.subtitle')}
          bgImage="https://readdy.ai/api/search-image?query=dark%20futuristic%20IT%20technology%20background%20with%20glowing%20cyan%20circuit%20board%20patterns%2C%20abstract%20digital%20code%20streams%2C%20deep%20navy%20graphite%20atmosphere%2C%20professional%20software%20development%20concept%2C%20ultra%20wide%20panoramic%2C%20cinematic%20dark%20moody%20lighting%2C%20subtle%20neon%20cyan%20accents%2C%20no%20people&width=1920&height=900&seq=it-hero-bg-001&orientation=landscape"
        />
        <ServiceFeatures features={features} />
        <ServiceDetails details={details} />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
